export default "__VITE_ASSET__qjbDkObi__"